import React, {Component} from 'react';
import './index.scss';
import desktop_exit from 'assets/icons/login-x-icon.svg';
import DragAndDrop from "../../../shared/drag_and_drop";
import {formatNumber, getMediaPath} from "../../../../app/functions";
import document from 'assets/icons/document.svg';
import {addPopup, removePopup, setUserApp} from "../../../../redux/actions";
import {connect} from "react-redux";
import Loader from "../../../../components/common/loader";
import {relationsApi} from "../../../../redux/api/relations.api";
import * as popups from "../../../../constants/popup-types";

class UploadFilePopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            popup_id: this.props.popup_id,
            file_uploaded: false,
            err: '',
            showLoader: false,
            isButtonClicked: false,
            isPopupClosed: false,
        };
        this.animateOut = this.animateOut.bind(this);
        this.animateIn = this.animateIn.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.popup_id !== state.popup_id) {
            return {animation_class: 'active'}
        }
        return {};
    }

    componentDidMount() {
        this.animateIn();
    }

    componentDidUpdate(prevProps) {
        if (this.props.leadStatus !== prevProps.leadStatus && this.props.leadStatus) {
            this.animateOut();
            this.setState({showLoader: false});
        }
    }

    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }

    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if (callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    handleOnClick = () => {
        if (!this.state.isPopupClosed && typeof this.props.action === 'function') {
            this.props.action();
            this.animateOut();
        }
    };

    handlePressOutside = () => {
        if (!this.props.requesting) {
            const payload = this.props.payload;
            this.props.sendUserApplication({...payload, isInComplete: true});
            this.setState({showLoader: true});
        }
    };

    handleDrop = (files) => {
        if (typeof files === 'string')
            this.setState({err: files});
        else
            this.setState({file_uploaded: files['0'], err: ''});
    };

    handleRemoveFile = () => {
        this.setState({file_uploaded: false});
    };

    handleApprove = () => {
        if (!this.state.isButtonClicked) {
            this.setState({showLoader: true, isButtonClicked: true});
            let payload = {...this.props.payload};
            payload['id_file'] = this.state.file_uploaded;
            this.props.sendUserApplication(payload);
        }
    };

    render() {
        const {text = 'General Message Text'} = this.props;
        const isDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';
        const btnText = this.props.btnText !== undefined ? this.props.btnText : 'אישור';

        return (
            <div className={"backdrop " + this.state.animation_class} onClick={() => this.handlePressOutside()}>
                <div className={"popup_wrapper upload_file " + this.state.animation_class}
                     onClick={(e) => e.stopPropagation()}>
                    <button className="x_close_icon"
                            onClick={() => this.handlePressOutside()}
                            disabled={this.state.isPopupClosed}
                            style={this.state.isPopupClosed ? {opacity: 0.5, pointerEvents: 'none'} : {opacity: 1}}>
                        <img src={getMediaPath(desktop_exit)} alt=''/>
                    </button>
                    <div className="popup_content">
                        <div className="text">{text}</div>
                        <span className={'sub-text'}>{this.props.Translations['upload_file_description']}</span>
                        {!this.state.file_uploaded &&
                            <div className='drop-wrapper'>
                                <DragAndDrop className={'drag-paper'}
                                             handleDrop={this.handleDrop}
                                             format={['pdf', 'png', 'jpg']}
                                             label={this.props.Translations['drag_n_drop_label']}
                                             max_size={6}/>
                                {isDesktop && <span className='drag-msg'>או גרור לכאן</span>}
                            </div>
                        }

                        {this.state.file_uploaded &&
                            <div className='files-div'>
                                <div className='file-name'>
                                    <img src={getMediaPath(document)} alt=''/>
                                    {this.state?.file_uploaded?.name}
                                </div>
                                <div className='file-size'>
                                    <span className='remove-file' onClick={this.handleRemoveFile}>X</span>
                                    {formatNumber(this.state?.file_uploaded?.size / 1000) + ' KB'}
                                </div>
                            </div>
                        }

                        <button className={"accept-button " + (this.state.file_uploaded ? '' : 'disabled')}
                                onClick={this.handleApprove}
                                disabled={this.state.isButtonClicked}
                                style={this.state.isButtonClicked ? {opacity: 0.5, pointerEvents: 'none'} : {opacity: 1}}
                                aria-label="אישור">{btnText}</button>
                    </div>
                </div>
                {this.state.showLoader &&
                    <Loader/>
                }
            </div>
        )
    }
}

const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        Translations: store.config.Translations,
        leadStatus: store.data.UserAppStatus,
        requesting: store.state.requesting,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        sendUserApplication: (payload) => {
            dispatch(relationsApi.endpoints.usersApplicationCreate.initiate(payload))
                .unwrap()
                .then((result) => {
                    dispatch(removePopup())
                    if (result?.valid) {
                        dispatch(setUserApp(true))
                    } else {
                        dispatch(addPopup({
                            type: popups.GENERAL_MESSAGE,
                            text: result?.message || 'תקלת שרת, אנא נסה שנית מאוחר יותר',
                            popup_id: Math.round(Math.random() * 1000000)
                        }))
                    }
                })
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, {pure: false})(UploadFilePopup);
